import { useDroppable } from '@dnd-kit/core'
import { SortableContext, verticalListSortingStrategy } from '@dnd-kit/sortable'
import UIElement from './UIElement'
import './PropertyPanel.css'

export interface UIElementData {
  id: string
  type: 'textfield' | 'slider' | 'checkbox' | 'dropdown'
}

interface PropertyPanelProps {
  elements: UIElementData[]
  selectedId: string | null
  onSelectElement: (id: string) => void
  onDeleteElement: (id: string) => void
  dragOverInfo: { id: string; position: 'before' | 'after' } | null
  activeId: string | null
}

function PropertyPanel({ elements, selectedId, onSelectElement, onDeleteElement, dragOverInfo, activeId }: PropertyPanelProps) {
  // 空のパネルにもドロップできるようにする
  const { setNodeRef: setEmptyDropRef } = useDroppable({
    id: 'property-panel-empty',
  })

  // ドラッグ中かどうかを判定
  const isDraggingFromToolbar = activeId?.startsWith('toolbar-')

  // パネルコンテンツのクラス名を決定
  const getContentClassName = () => {
    const classes = ['property-panel-content']
    if (elements.length === 0 && isDraggingFromToolbar) {
      classes.push('drop-target-active')
    }
    if (isDraggingFromToolbar) {
      classes.push('accepting-new-element')
    }
    return classes.join(' ')
  }

  return (
    <div className="property-panel">
      <div className="property-panel-header">
        <h3>プロパティパネル</h3>
        <span className="element-count">要素数: {elements.length}</span>
      </div>
      <div className={getContentClassName()}>
        {elements.length === 0 ? (
          <div
            ref={setEmptyDropRef}
            className={`empty-message ${isDraggingFromToolbar ? 'drag-active' : ''}`}
          >
            左のツールをドラッグしてここにドロップして要素を追加してください
          </div>
        ) : (
          <SortableContext
            items={elements.map(el => el.id)}
            strategy={verticalListSortingStrategy}
          >
            {elements.map((element) => (
              <UIElement
                key={element.id}
                id={element.id}
                type={element.type}
                isSelected={element.id === selectedId}
                onClick={() => onSelectElement(element.id)}
                onDelete={() => onDeleteElement(element.id)}
                dragPosition={dragOverInfo?.id === element.id ? dragOverInfo.position : null}
              />
            ))}
          </SortableContext>
        )}
      </div>
    </div>
  )
}

export default PropertyPanel
